module.exports = __webpack_public_path__ + "static/img/4.27a0adda.png";